import { createAction, createSlice } from "@reduxjs/toolkit";

const getTotalReviewInstructorSlice = createSlice({
  name: "getTotalReviewInstructor",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.data = action.payload.data;
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = getTotalReviewInstructorSlice;
const getTotalReviewInstructorAction = createAction(name);

export {
  getTotalReviewInstructorAction,
  actions as getTotalReviewInstructorActions,
  reducer as getTotalReviewInstructorReducer,
};
